import { fetchMetaDataApi  } from '../../services/common-api';
import { fetchReportsDataApi } from '../../services/nmbs-users-api';

export const fetchReportsData = () => {
    return fetchReportsDataApi();
}

export const fetchMetaData = () => {
    return fetchMetaDataApi(2);
}